import { render } from "./NotificationBar.vue?vue&type=template&id=10ff5152&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"

import "./NotificationBar.vue?vue&type=style&index=0&id=10ff5152&lang=scss"
import "./NotificationBar.vue?vue&type=style&index=1&id=10ff5152&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ff5152"]])

export default __exports__